// extracted by mini-css-extract-plugin
export default {"AboutHero":"AboutHeroBase_AboutHero__uKkN8","Left":"AboutHeroBase_Left__WqWgB","Right":"AboutHeroBase_Right__zkV+r","Plus":"AboutHeroBase_Plus__6oduM"};